import { selfServiceApiClient } from 'config/selfServiceApi';
import { getMe, updateVisitor } from 'services/ApiService';

/**
 * Fetches current user(visitor/client)'s data
 * @returns
 */
export const getUserProfile = async () => {
  try {
    const response = await getMe();
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.error(err);
  }
  return null;
};

/**
 *
 */
export const updateProfile = async (visitor) => {
  try {
    const response = await updateVisitor(visitor);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.error(err);
  }
  return null;
};

export const updateMarketingPreferences = (clientId, data = {}) => {
  return selfServiceApiClient.put(
    `/api/self-service/visitor/${clientId}/marketingPreferences`,
    data,
  );
};

export const getMarketingPreferences = (clientId) => {
  return selfServiceApiClient.get(
    `/api/self-service/visitor/${clientId}/marketingPreferences`,
  );
};

export const getClientApis = () => {
  return selfServiceApiClient.get('/api/self-service/apis');
};

export const updateClientApi = (apiId, data = {}) => {
  return selfServiceApiClient.put(`/api/self-service/apis/${apiId}`, data);
};

export const createClientApi = (data = {}) => {
  return selfServiceApiClient.post('/api/self-service/apis/', data);
};

export const deleteClientApi = (apiId) => {
  return selfServiceApiClient.delete(`/api/self-service/apis/${apiId}`);
};

export const updatePassengerApis = (apiId, data = {}) => {
  return selfServiceApiClient.put(`/api/self-service/bookings/${apiId}/apis`, data);
};

export const getVisitorTags = (clientId) => {
  return selfServiceApiClient.get(`/api/self-service/visitor/${clientId}/tags`);
};

export const updateVisitorTags = (clientId, data = {}) => {
  return selfServiceApiClient.put(
    `/api/self-service/visitor/${clientId}/tags`,
    data,
  );
};
